import React from 'react';
import PropTypes from 'prop-types';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ButtonRadioField extends React.Component {
  constructor(props) {
    super(props);
    this.toggleButtonFocusClass = this.toggleButtonFocusClass.bind(this);
  }

  toggleButtonFocusClass(element) {
    const { classes } = this.props;

    element.target.parentNode.parentNode.parentNode.classList.toggle(
      classes.buttonFocused
    );
  }

  render() {
    const {
      classes,
      options,
      fieldName,
      value,
      onChange,
      onMouseDown,
      onKeyDown,
    } = this.props;

    return (
      <RadioGroup
        className={classes.radioGroupButtons}
        row
        name={fieldName}
        value={value}
        onChange={onChange}
        onMouseDown={onMouseDown}
        onKeyDown={onKeyDown}
      >
        {options.map((option, i) => {
          return (
            <FormControlLabel
              className={classes.formControlLabel}
              value={option.value}
              control={
                <Radio
                  classes={{
                    root: classes.radioButton,
                    checked: classes.radioButtonChecked,
                  }}
                  onFocus={this.toggleButtonFocusClass}
                  onBlur={this.toggleButtonFocusClass}
                />
              }
              label={option.label}
              key={i}
            />
          );
        })}
      </RadioGroup>
    );
  }
}

ButtonRadioField.propTypes = {
  classes: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func,
  onKeyDown: PropTypes.func,
};

ButtonRadioField.defaultProps = {
  onMouseDown: null,
  onKeyDown: null,
};

export default withStyles(styles)(ButtonRadioField);
